import lod_ from "lodash";

/**
 * A forward action (v2) sends the mail right away, without draft, when its config has "autoSend" set to true
 * @param {object} action the action of the assistantConfig
 * @returns {boolean}
 */
export function isAutoSendForwardAction(action) {
	return (
		action?.version === "2.0" && action?.type === "forward" && action?.config?.autoSend === true
	);
}

/**
 * The auto send forward of a conversation forwards its first message, so it is only offered
 * for a conversation with one incoming message and no answer yet
 * @param {object} conversation the selected conversation
 * @returns {boolean}
 */
export function isAutoSendConversationEligible(conversation) {
	return (
		conversation?.meta?.totalMessageIn === 1 &&
		conversation?.meta?.totalMessageOut === 0 &&
		!lod_.isEmpty(conversation?.messages)
	);
}
